<ion-list inset lines="none">
    <div class="header" (click)="collapse()">
        <mits-form-header
                [title]="title"
                [description]="description"
                [showAdd]="showAdd"
                (addClicked)="navigateToNewDamageReport()">
        </mits-form-header>

        <ion-icon
                [name]="collapsed ? 'chevron-down' : 'chevron-up'"
                color="tertiary">
        </ion-icon>
    </div>

    <ng-container *ngIf="!collapsed">
        <ion-searchbar mode="ios" placeholder="Suchen..." i18n-placeholder
                       [formControl]="searchControl"></ion-searchbar>
        <ion-segment
                *ngIf="(damageReportCounts$ | async) as counts"
                [formControl]="segmentControl"
        >
            <ion-segment-button layout="icon-start" [value]="DamageListItemStateEnum.ALL">
                <ion-label class="ion-hide-md-down">Alle</ion-label>
                <ion-icon name="ellipse-outline"></ion-icon>
            </ion-segment-button>

            <ion-segment-button
                    [disabled]="!counts.get(DamageListItemStateEnum.OPEN)"
                    class="open"
                    layout="icon-start"
                    value="0"
            >
                <ion-label class="ion-hide-md-down">Offen</ion-label>
                <ion-icon name="ellipse"></ion-icon>
            </ion-segment-button>

            <ion-segment-button
                    [disabled]="!counts.get(DamageListItemStateEnum.IN_PROGRESS)"
                    class="edit"
                    layout="icon-start"
                    value="1"
            >
                <ion-label class="ion-hide-md-down">In Bearbeitung</ion-label>
                <ion-icon name="ellipsis-horizontal-circle-sharp"></ion-icon>
            </ion-segment-button>

            <ion-segment-button
                    [disabled]="!counts.get(DamageListItemStateEnum.FINISHED)"
                    class="finished"
                    layout="icon-start"
                    value="2"
            >
                <ion-label class="ion-hide-md-down">Abgeschlossen</ion-label>
                <ion-icon name="checkmark-circle"></ion-icon>
            </ion-segment-button>

            <ion-segment-button
                    [disabled]="!counts.get(DamageListItemStateEnum.CANCELLED)"
                    class="cancelled"
                    layout="icon-start"
                    value="3"
            >
                <ion-label class="ion-hide-md-down">Storniert</ion-label>
                <ion-icon name="close-circle"></ion-icon>
            </ion-segment-button>
        </ion-segment>


        <ng-container *ngIf="(filteredSortedDamageReports$ | async) as damageReports">
            <ng-container *ngIf="damageReports.length > 0; else noData">
                <mits-data-grid
                        [isOrderableOnMobile]="true"
                        [orderedByIndicator]="orderByControl.value"
                        (orderBy)="orderByControl.setValue($event)"
                        [data]="damageReports"
                        [columnConfigs]="columns"
                        (itemClicked)="navigateToExistingDamageReport($event)"
                        [itemsClickable]="true">
                </mits-data-grid>
            </ng-container>

            <ng-template #noData>
                <ion-label class="ion-margin" color="tertiary" style="display:block">
                    Keine Schäden vorhanden.
                </ion-label>
            </ng-template>
        </ng-container>
        <ion-button
                *ngIf="showAdd"
                class="ion-no-margin"
                expand="full"
                color="primary"
                (click)="navigateToNewDamageReport()"
        >
            Schadensmeldung erstellen
        </ion-button>
    </ng-container>
</ion-list>
